export const lookup = "site-config-lookups/inferno";
//# sourceMappingURL=lookup.js.map